export default __webpack_public_path__ + "static/media/flag-curaçao.9a65ab6d.svg";